import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from "src/app/app.main.component";
import { ConfigurationService } from 'src/app/configurations/configurationService';

@Component({
  selector: 'user-details-modal',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})

export class UserDetailsModalComponent implements OnInit , OnChanges {

  @Input() display = false;
  @Input() selectedUserId;
  @Output() close = new EventEmitter();
  users: any[] = []
  selectedUser: any;

  public fileData: any;
  changedPic = false;
  /** Subscription and Cleanup */
  protected ngUnsubscribe$: Subject<void> = new Subject<void>(); 

  index: number = 0;
  address = [
    { id: 1, type: "Home Address", street1: "5 werifds way", street2: "", city: "New Yprk", state: "NY", county: "US", zipcode: "08899" },
    { id: 2, type: "Office Address", street1: "566w uiew dr.", street2: "", city: "New Yprk", state: "NY", county: "US", zipcode: "08456" },
  ]
  socialData = [
    { id: 1, name: "Facebook", url: "https://www.facebook.com", type: "system" },
    { id: 2, name: "LinkedIn", url: "https://www.linkedin.com/in", type: "system" },
    { id: 3, name: "Website", url: "https://www.lionobytes.com", type: "system" },
  ]
  social = [];

  //communication
  communication = [
    { id: 1, name: 'SMS', isSubscrib: true, unSubscrib: false },
    { id: 2, name: 'WhatsApp', isSubscrib: true, unSubscrib: false },
    { id: 3, name: 'Work Email', isSubscrib: true, unSubscrib: false },
    { id: 4, name: 'Home Email', isSubscrib: true, unSubscrib: false },
    { id: 4, name: 'Work Phone', isSubscrib: false, unSubscrib: true },
    { id: 5, name: 'Mobile Phone', isSubscrib: false, unSubscrib: true },
  ];

  constructor(
    public readonly app: AppMainComponent,
    private readonly service: ConfigurationService,
    private readonly appMainService: AppMainService,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
  
  ) {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes?.selectedUserId?.currentValue)
      this.getUserDetails(this.selectedUserId);
  }


  ngOnInit(): void {
    this.users = this.app.usersList;
  }


  getUserDetails(userId) {
    this.appMainService.isShowSpinner('getUserDetails');
    this.service.getOrgUserById(userId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('getUserDetails');
        this.selectedUser = response;
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getUserDetails');
      }
    })
  }

  selectFile(event) {
    this.fileData = <File>event.target.files[0];
    this.preview();
  }

  public preview() {
    var mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.app.profilePic = reader.result + "";
      this.changedPic = true;
      //this.uploadProfileImage();
    }
  }
  onClose() {
    this.close.emit();
  }

  ngOnDestroy() {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }
}


